import * as React from 'react';
import { withNodeResizable } from '../shared/NodeResizable';
import { Portal } from '../shared/Portal';
import { createEmbedExtension } from '../shared/createEmbedExtension';
import { EmbedRendererProps } from '../shared/types';

const URL_REGEX = /^https:\/\/trello.com\/(c|b)\/([^/]*)(.*)?$/;
export const ENABLED = [URL_REGEX];

export const Component = ({ url, ...rest }: EmbedRendererProps<any>) => {
  const { embedUrl, title } = React.useMemo(() => {
    const matches = URL_REGEX.exec(url);
    const type = matches?.[1];
    const objectId = matches?.[2];

    if (type === 'c') {
      return {
        embedUrl: `https://trello.com/embed/card?id=${objectId}`,
        title: 'Trello Card',
      };
    }
    return {
      embedUrl: `https://trello.com/embed/board?id=${objectId}`,
      title: 'Trello Board',
    };
  }, [url]);

  return <Portal {...rest} url={embedUrl} title={title} />;
};

export default createEmbedExtension({
  regexp: [URL_REGEX],
  name: 'trello-embed',
  component: withNodeResizable(Component, {
    lockAspectRatio: true,
  }),
  addCommandOption: {
    title: 'Trello',
    description: 'Embed a Trello card or board.',
    searchTerms: ['embed', 'trello'],
    icon: 'logos:trello',
  },
});
